import template from './users.html'

class UsersPageVM
{
	constructor (page)
	{
		this.page = page;
		this.active_users = ko.observableArray([]);
		this.search_string = ko.observable('');
		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(20);
		this.page_count = ko.observable(1);
		this.sort_field = ko.observable('username');
		this.sort_order = ko.observable('ASC');
		this.display_inactive = ko.observable(false);
		this.display_inactive.subscribe(() => {
			this.current_page_number(1);
			this.page.updateData();
		});

		this.columns = ko.observableArray(['Username', 'Fullnames', 'Email',  'OTP Methods', 'Last Login', 'Groups']);
		this.visible_columns = ko.observableArray(['Username', 'Fullnames', 'Email',  'OTP Methods', 'Last Login', 'Groups']);

		this.visible_columns.subscribe((newVal) => {
			localStorage.setItem('ui.manage-users.visible_columns', JSON.stringify(this.visible_columns()));
		});
	}

	btn_add_user_click ()
	{
		this.page.edit_user(null);
	}

	back_to_top ()
	{
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	btn_page_click (page_number)
	{
		this.current_page_number(page_number);
		this.page.updateData();
	}

	btn_search_click ()
	{
		this.page.updateData();
	}

	btn_reset_password_click (row)
	{
		this.page.reset_password(row.username);
	}

	async btn_switch_user_click (row)
	{
		let obj = {
			uuid: row.uuid,
			username: row.username
		};

		let response = await fetch(`/api/session/switch-user`, { 
			method: 'POST',
			headers: {'content-type': 'application/json'},
			body: JSON.stringify(obj)
		});

		let data = await response.json();

		if (data.status == 'ERROR')
			Grape.alerts.alert({type: 'error', title: 'Error', message: data.message});
		else
			window.location.reload();
	}

	btn_edit_click (row)
	{
		this.page.edit_user(row);
	}

	async btn_deactivate_click (row)
	{
		row.active = false;

		let response = await fetch('/api/user', {
			method: 'POST',
			headers: {'content-type': 'application/json'},
			body: JSON.stringify({
				username: row.username,
				active: row.active
			})
		});
		this.page.updateData();
	}

	async btn_activate_click (row)
	{
		row.active = true;
		let response = await fetch('/api/user', {
			method: 'POST',
			headers: {'content-type': 'application/json'},
			body: JSON.stringify({
				username: row.username,
				active: row.active
			})
		});
		this.page.updateData();
	}

	get_last_login_display (row)
	{
		if (!row.auth_last_login)
			return 'Never';
		return moment(row.auth_last_login).fromNow();
	}

	get_formatted_roles (user)
	{
		return ko.pureComputed(() => {
			let roleNames = user.role_names || [];
			let assignedRoleNames = user.assigned_role_names || [];
			return roleNames.map(r => {
				if (assignedRoleNames.indexOf(r) >= 0)
					return `<span style="font-weight: bold;">${r}</span>`;
				else
					return `<span style="color: #afafaf; font-style: italic;">${r}</span>`;
			}).join(', ');
		}, this);
	}

	sort_column (column)
	{
		if (this.sort_field() === column)
			this.sort_order(this.sort_order() === 'ASC' ? 'DESC' : 'ASC');
		else
		{
			this.sort_field(column);
			this.sort_order('ASC');
		}
			
		this.page.updateData();
	}
}

class UsersPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new UsersPageVM(this);

		const searchInput = document.getElementById('searchInput');
		searchInput.addEventListener('keyup', (event) => {
			if (event.key === 'Enter')
				this.updateData();
		});
	}

	init ()
	{
		document.title = 'Dashboard - Users';

		let visible_columns = localStorage.getItem('ui.manage-users.visible_columns');
		if (visible_columns)
			this.viewModel.visible_columns(JSON.parse(visible_columns));

		this.updateData();
	}

	async updateData ()
	{
		let access_roles = await Grape.cache.fetch('AccessRoles');

		let users_result = {
			table: 'v_users', 
			schema: 'users',
			offset: 0,
			filter_join: 'AND',
			join: 'OR',
			filter: [],
			sortorder: this.viewModel.sort_order(),
			sortfield: this.viewModel.sort_field()
		}

		// LOGIC: Search
		if (this.viewModel.search_string() && this.viewModel.search_string() != '') 
		{
			users_result.filter.push({ 
				field: 'username', 
				operand: 'ILIKE', 
				value: `%${this.viewModel.search_string()}%` 
			});
		}

		// LOGIC: Hide inactive users by default
		if (!this.viewModel.display_inactive())
		{
			users_result.filter.push({
				field: 'active',
				operand: '=',
				value: true
			});
		}

		// LOGIC: Pagination
		if (this.viewModel.current_page_number() && this.viewModel.current_page_size())
		{
			users_result.limit = this.viewModel.current_page_size();
			users_result.offset = (this.viewModel.current_page_number()-1) * this.viewModel.current_page_size();
		}

		let users = await Grape.fetches.getJSON('/api/record', users_result);

		if (users.status != 'OK')
			throw new Error(users.message || users.code);
		
		let records = [];
		for (let r of users.records)
		{
			r.groups = [];
			for (let role_name of r.role_names)
			{
				let access_role = access_roles.find((ar) => ar.role_name == role_name);
				if (access_role && access_role.role_type == 'GROUP')
					r.groups.push(access_role);
			}
			records.push(r);
		}

		this.viewModel.active_users(records);
		this.viewModel.page_count(Math.floor(users.total/users.limit)+1);
	}

	async reset_password (username)
	{
		try
		{
			let result = await Grape.dialog.open('DataInputDialog', {
				fields: [{
					name: 'new_password', 
					type: 'password', 
					label: 'New Password'
				}],
				title: 'Reset Password',
				message: 'Please provide password for ' + username,
				data: {}
			});

			let response = await fetch('/api/user', {
				method: 'POST',
				headers: {'content-type': 'application/json'},
				body: JSON.stringify({
					username,
					password: result.new_password
				})
			});
			let data = await response.json();

			if (data.status == 'ERROR')
				throw new Error(data.message);
			else
				Grape.alerts.alert({type: 'success',  title: 'Success', message: 'User password has been reset.'});
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: 'Error',  message: error.message });
		}
	}

	async edit_user (row)
	{
		if (!row || !row.user_id)
		{
			let user_info = await Grape.dialog.open('UserEdit', row);
			if (!user_info)
				return;

			try
			{
				let response = await fetch('/api/user', {
					method: 'POST',
					headers: {'content-type': 'application/json'},
					body: JSON.stringify(user_info)
				});
				let data = await response.json();

				if (data.status == 'OK')
				{
					Grape.alerts.alert(
					{
						type: 'success',
						message:  'New user added',
						title: user_info.username
					});
					this.updateData();
				}
				else
					throw new Error(data.message);
			} catch (error) {
				console.error(error);
				Grape.alerts.alert({type: 'error', title: 'Error',  message: error.message });
			}
			return;
		}

		window.__ps_profile_target_user_id = row.user_id;
		window.dispatchEvent(new CustomEvent('ui.users-manage.open-profile', {
			detail: { user_id: row.user_id }
		}));

		if (window.location.pathname.indexOf('/ui/users/manage') < 0)
			Grape.navigate('/ui/users/manage');
	}
}

export default {
	route: '[/]ui/admin/users',
	page_class: UsersPage,
	template: template,
	name: 'users',
	title: 'Users',
	icon: 'fa-regular fa-users'
}
